import(/* webpackMode: "eager", webpackExports: ["ConfigProvider"] */ "__barrel_optimize__?names=ConfigProvider!=!/workspace/online-customer-service-fe/node_modules/.pnpm/antd@5.29.3_date-fns@2.30.0_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["CommonParamsProvide"] */ "/workspace/online-customer-service-fe/app/components/commonParamsProvide.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/online-customer-service-fe/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/workspace/online-customer-service-fe/app/lib/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocaleProvider"] */ "/workspace/online-customer-service-fe/app/lib/LocaleProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SentryProvider"] */ "/workspace/online-customer-service-fe/app/lib/SentryProvider.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/online-customer-service-fe/app/theme.css");
